import Utils from '../framework/utils.js';
import DataEvent from '../framework/data-event.js';
import TomSelect from 'tom-select';

class MapFilterView extends EventTarget {
  constructor(tmpl, model) {
    super();
    Utils.bindMethods(this, ['onModelChange', 'onFieldChange', 'onSubmitClick', 'onResetClick']);
    this.dom = tmpl;

    this.render(model);
    model.addEventListener('Model.Change', this.onModelChange);
    this.dom.querySelectorAll('select, input').forEach((field) => {
      field.addEventListener('change', this.onFieldChange);
    })
    this.dom.querySelector('.map_filter-form_submit').addEventListener('click', this.onSubmitClick);
    this.dom.querySelector('.map_filter-form_reset').addEventListener('click', this.onResetClick);
  }

  render(model) {
    this.dom.querySelector('.map_filter-form_division').value = model.get('selectedFilter.division.id') ? model.get('selectedFilter.division.id') : '';
    this.dom.querySelector('.map_filter-form_location-type').value = model.get('selectedFilter.locationType.id') ? model.get('selectedFilter.locationType.id') : '';

    this.dom.querySelectorAll('.map_filter-form_division option').forEach((opt) => {
      opt.classList.toggle('d-none', !Utils.isEmpty(opt.getAttribute('value')) && !model.get('options.displayed.division').flatMap((a) => a.id).includes(opt.getAttribute('value')))
    })
    this.dom.querySelectorAll('.map_filter-form_location-type option').forEach((opt) => {
      opt.classList.toggle('d-none', !Utils.isEmpty(opt.getAttribute('value')) && !model.get('options.displayed.locationType').flatMap((a) => a.id).includes(opt.getAttribute('value')))
    })
  }

  onModelChange(evt) {
    this.render(evt.currentTarget);
  }

  onFieldChange(evt) {
    this.dispatchEvent(new DataEvent(MapFilterView.Events.CHANGE, {
      division: this.dom.querySelector('.map_filter-form_division').value,
      locationType: this.dom.querySelector('.map_filter-form_location-type').value,
    }))
  }

  onSubmitClick(evt) {
    evt.preventDefault();
    this.dispatchEvent(new Event(MapFilterView.Events.SUBMIT))
    return false;
  }
  onResetClick(evt) {
    evt.preventDefault();
    this.dispatchEvent(new Event(MapFilterView.Events.RESET));
    return false;
  }
}

MapFilterView.Events = {
  CHANGE: 'MapFilterView.Change',
  RESET: 'MapFilterView.Reset',
  SUBMIT: 'MapFilterView.Submit'
}

export default MapFilterView;